import {TransactionExpiration} from '../lib/paymentUtils';
import useAsyncStorage from './useAsyncStorage';
import {ASYNC_STORAGE} from '../storage/storageKeys';

export const useSettings = () => {
  return useAsyncStorage(ASYNC_STORAGE.APP_SETTINGS, {
    showQR: true,
    showDescription: false,
    useBiometricAuth: false,
    transactionExpiration: TransactionExpiration.MINUTES_15
  });
};
